import { IconRotate2 } from '@tabler/icons-react';
import { useProposal } from '../../context/ProposalContext';
import { Button, Loader, Modal, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useDisclosure } from '@mantine/hooks';
import { useGeneration } from '@/hooks/useGeneration';

export default function RegenerateScope() {
  const { proposal, dispatchProposal, userFeedback, dispatchUserFeedback, dispatchOtherData } =
    useProposal();
  const { loadingScope } = userFeedback;
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure();

  const { withService, cancelField } = useGeneration({
    dispatchProposal,
    dispatchUserFeedback,
    dispatchOtherData,
  });

  const handleGenerateScope = async () => {
    const config = {
      input: proposal.input,
      documentLanguage: proposal.language,
      proposal,
    };

    withService(async (svc) => {
      await svc.generateScope(config, {
        dispatchProposal,
        dispatchUserFeedback,
        dispatchOtherData,
      });
    });
    close();
  };

  const handleCancel = () => {
    cancelField('scope');
  };

  return (
    <>
      <Button
        color={loadingScope ? 'orange' : 'cyan'}
        variant="light"
        size="xs"
        leftSection={loadingScope ? <Loader size="xs" color="cyan" /> : <IconRotate2 size={16} />}
        onClick={loadingScope ? handleCancel : open}
      >
        {loadingScope ? t('cancel') : t('regenerate')}
      </Button>

      <Modal opened={opened} onClose={close} title={t('confirmRegeneration')}>
        <div>{t('confirmRegenerateScope')}</div>
        <Group justify="flex-end" mt="md">
          <Button color="gray" onClick={close}>
            {t('cancel')}
          </Button>
          <Button color="cyan" onClick={handleGenerateScope}>
            {t('confirm')}
          </Button>
        </Group>
      </Modal>
    </>
  );
}
